
import { useEffect } from 'react';
import * as microsoftTeams from '@microsoft/teams-js';
import { TeamsRoutes } from '../../routes/route.path';
import Config from '../../../config';

const MicrosoftLoginStart = () => {
    useEffect(() => {
        const scope = "https://graph.microsoft.com/user.read https://graph.microsoft.com/files.read"
        microsoftTeams.initialize();
        const authorizeParams = new URLSearchParams({
            tenant: "4996a77c-e0a6-468e-88aa-8c6a054467de",
            client_id: Config.SSO_LOGIN_AZURE_AD_CLIENT_ID,
            response_type: "code",
            scope: "https://graph.microsoft.com/.default",
            redirect_uri: window.location.origin + TeamsRoutes.TEAMS_CONCENTPOPUP_END
        });

        const authorizeEndpoint = `https://login.microsoftonline.com/edb4c8cb-528b-440e-a593-0869c59f1018/oauth2/v2.0/authorize?${authorizeParams.toString()}`;

        console.log("authorizeEndpoint:", authorizeEndpoint);

        window.location.assign(authorizeEndpoint);

    }, []);

    return (
        <div className="ms-Fabric">
            <div id="content">
                <p>Redirecting to Azure AD to request permission consent</p>
            </div>
        </div>
    );
};

export default MicrosoftLoginStart;
